import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function AddPeriodToTemplateDialog({  
  closeDialog,
  handleAddPeriodToTemplate,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    noOfWeeks: "",
    periodName: "",
  });
  const [periodNameValue, setPeriodNameValue] = useState("");
  const [descValue, setDescValue] = useState("");
  
  const [noOfWeeks, setNoOfWeeks] = useState(1);
  const [inSprint, setInSprint] = useState(false);

  
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleSave = () => {
    if (periodNameValue.trim() === "") {
      setErrorMsg({ periodName: "Period Name cannot be blank." });
    } else if (noOfWeeks < 1) {
      setErrorMsg({ noOfWeeks: "Enter an integer greater than zero." });
    } else if (!noOfWeeks) {
      setErrorMsg({ noOfWeeks: "No of Weeks cannot be blank." });
    } else {
      setOpen(false);
      handleAddPeriodToTemplate(
        periodNameValue,        
        descValue,
        noOfWeeks,
        inSprint
      );
    }
  };

  const handlePeriodNameChange = (event) => {
    if (event.target.value.trim() === "")
      setErrorMsg({ periodName: "Period Name cannot be blank." });
    else setErrorMsg({ periodName: "" });
    setPeriodNameValue(event.target.value);
  };
  const handleDescChange = (event) => {
    // Limit input to 254 characters
    if (event.target.value.length <= 254) {
      setDescValue(event.target.value);
    }
  };
  const validateNoOfWeeks = (value) => {
    setNoOfWeeks(parseInt(value));
    if (parseInt(value) < 1) {
      setErrorMsg({ noOfWeeks: "Enter an integer greater than zero." });
    } else if (value.toString().trim() === "") {
      setErrorMsg({ noOfWeeks: "No of Weeks cannot be blank." });
    } else {
      setErrorMsg({ noOfWeeks: "" });      
    }
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Add Period
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              autoFocus
              required
              label="Period Name"
              margin="normal"
              name="periodName"
              variant="outlined"
              id="periodName"
              value={periodNameValue}
              onChange={handlePeriodNameChange}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.periodName}
              </FormHelperText>
            )}
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              label="Description"
              margin="normal"
              name="Description"
              variant="outlined"
              id="Description"
              value={descValue}
              onChange={handleDescChange}
              multiline
              rows={4}
            />
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              required
              label="No of Weeks"
              margin="normal"
              name="noOfWeeks"
              type="number"
              value={noOfWeeks}
              variant="outlined"
              InputProps={{
                inputProps: { min: 0, pattern: "[0-9]*" },
              }}
              onKeyPress={(e) => {
                if (e?.key === "-" || e?.key === "+") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => validateNoOfWeeks(e.target.value)}
              id="noOfWeeks"
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.noOfWeeks}
              </FormHelperText>
            )}
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              
            </Box>
            <Typography variant="h3">
              In Sprint?{" "}
              <Checkbox
                onChange={(e) => setInSprint(e.target.checked)}
                id="In Sprint"
              />
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
